import { render, staticRenderFns } from "./experience.vue?vue&type=template&id=42b2988c&scoped=true&"
import script from "./experience.vue?vue&type=script&lang=js&"
export * from "./experience.vue?vue&type=script&lang=js&"
import style0 from "./experience.vue?vue&type=style&index=0&id=42b2988c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b2988c",
  null
  
)

export default component.exports